const InitialUserCrud = {
    LocationTypes : [],
    Locations : [],
    Cargos: [],
}

export default function UserCurdReducer ( PrevState = InitialUserCrud, action){
    switch (action.type) {
        case 'changeLoations':
            return{
                ...PrevState,
                Locations : action.payload.Locations
            };
        case 'changeLoationtypes':
            return{
                ...PrevState,
                LocationTypes : action.payload.Types
            };
        case 'changeCargos':
            return {
                ...PrevState,
                Cargos : action.payload.Cargos
            };
        default:
            return PrevState;
    }
}